module.exports = __webpack_public_path__ + "static/media/map-marker-plus.d42fb0bb.svg";